import React from 'react';
import {
  TResponsiveTableCellRenderer,
  TResponsiveTableCellRendererProps,
} from '../types';

const NoMemoHTMLCellRenderer: TResponsiveTableCellRenderer<{ html: string }> =
  React.forwardRef<
    HTMLTableCellElement,
    TResponsiveTableCellRendererProps<{ html: string }>
  >(
    (
      {
        cell: { children, Renderer, rendererProps, AccordionRenderer, ...cell },
        column,
        row,
        ...props
      },
      currentRef,
    ) => (
      <td
        ref={currentRef as React.RefObject<HTMLTableCellElement>}
        {...props}
        {...cell}
        dangerouslySetInnerHTML={{
          __html: String(rendererProps?.html ?? children ?? '').replaceAll(
            /<TOK(\d+)/g,
            '&lt;TOK$1',
          ),
        }}
      />
    ),
  );

NoMemoHTMLCellRenderer.displayName = 'HTMLCellRenderer';

export const HTMLCellRenderer = NoMemoHTMLCellRenderer;
